import { Link as RouterLink } from 'react-router-dom'

import { Link, Text } from '@buffer-mono/popcorn'

import { DraftNotesArchive } from '~publish/components/ContentItemNotes'
import { getChannelNameForDisplay } from '~publish/helpers/getChannelNameForDisplay'
import { postPermalinkRoute } from '~publish/legacy/routes'

import styles from './ContentItemNotesArchive.module.css'

import type { JSX } from 'react'

export type ArchivePost = {
  id: string
  channel: { service: string; name: string | null; displayName?: string | null }
}

/**
 * Where a Note link lands once its draft was scheduled: the closed draft
 * thread, with a link to the Notes of each Post the reader can see. With
 * none visible it is the archive alone.
 */
export function ContentItemNotesArchive({
  contentItemId,
  posts,
}: {
  contentItemId: string
  posts: readonly ArchivePost[]
}): JSX.Element {
  return (
    <div className={styles.page}>
      <div className={styles.panel}>
        <DraftNotesArchive contentItemId={contentItemId}>
          {posts.length > 0 && (
            <nav aria-label="Post notes">
              <ul className={styles.posts}>
                {posts.map((post) => (
                  <li key={post.id}>
                    <Link
                      as={RouterLink}
                      to={postPermalinkRoute.getRoute({ postId: post.id })}
                    >
                      {getChannelNameForDisplay(post.channel)}
                    </Link>{' '}
                    <Text as="span" size="sm" color="subtle">
                      {post.channel.service}
                    </Text>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </DraftNotesArchive>
      </div>
    </div>
  )
}
